/* Vangarde Seamless — sincroniza el selector custom de color con la galería Horizon.
 * Solo corre en /products/vangarde-seamless.
 */
(function () {
  'use strict';

  if (!/\/products\/vangarde-seamless(?:$|[/?#])/i.test(window.location.pathname + window.location.search)) return;

  function norm(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function getPicker() {
    return document.querySelector('variant-picker[data-product-url*="/products/vangarde-seamless"], variant-picker[data-product-id="10569977790645"]');
  }

  function hideNativePicker() {
    var picker = getPicker();
    if (picker) picker.style.display = 'none';
  }

  function syncColor(color) {
    var picker = getPicker();
    if (!picker) return;

    var wanted = norm(color);
    var target = null;

    // Horizon con botones/radios.
    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length && !target; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend || norm(legend.textContent).indexOf('color') !== 0) continue;

      var inputs = fieldsets[i].querySelectorAll('input[type="radio"]');
      for (var j = 0; j < inputs.length; j++) {
        if (norm(inputs[j].value) === wanted || norm(inputs[j].getAttribute('aria-label')).indexOf(wanted) === 0) {
          target = inputs[j];
          break;
        }
      }
    }

    if (target) {
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Fallback por si el picker cambia a dropdown en el editor del theme.
    var selects = picker.querySelectorAll('select');
    for (var k = 0; k < selects.length; k++) {
      var select = selects[k];
      var name = norm(select.name);
      var label = select.id ? document.querySelector('label[for="' + CSS.escape(select.id) + '"]') : null;
      if (name.indexOf('color') === -1 && (!label || norm(label.textContent).indexOf('color') !== 0)) continue;

      for (var o = 0; o < select.options.length; o++) {
        if (norm(select.options[o].value) === wanted || norm(select.options[o].textContent) === wanted) {
          if (select.selectedIndex !== o) {
            select.selectedIndex = o;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }
    }
  }

  // El pack builder vive en la descripción y puede tener 1 o 2 selectores de color.
  // El último selector tocado controla qué color se muestra en la galería.
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!(el instanceof HTMLSelectElement) || !el.classList.contains('bsc-color')) return;
    syncColor(el.value);
  });

  // El variant-picker se morphea al actualizar; mantenemos oculto el picker nativo
  // que el pack builder reemplaza visualmente.
  document.addEventListener('variant:update', function () {
    hideNativePicker();
  });

  hideNativePicker();
})();
